import type { Component } from 'solid-js'
import { Show } from 'solid-js'
import type { VideoData } from '../../../features/engagement/domain/models/videos'
import Video from '../../../assets/icons/Video'
import ValueProgressCell from './custom-cells/ValueProgressCell'
import { KPI, KPIType } from '../../../features/analytics/domain/models/kpi'
import { NumericalDataType } from '../../../shared/models/numerical-data-type'

export interface VideosTableRowProps {
  readonly video: VideoData
  readonly rowNumber: number
}

const VideosTableRow: Component<VideosTableRowProps> = (props) => {
  const calcPrevValue = (value: number | undefined, ratio: number): number | undefined => {
    if (value === undefined) {
      return undefined
    }

    const divisor = 1 + ratio
    if (divisor === 0) {
      return undefined
    }

    return value / divisor
  }

  const timesPlayedKPI = () =>
    new KPI(
      KPIType.TimesPlayed,
      props.video.timesPlayed,
      NumericalDataType.Units,
      props.video.timesPlayedChange,
      calcPrevValue(props.video.timesPlayed, props.video.timesPlayedChange)
    )

  const uniqueListenersKPI = () =>
    new KPI(
      KPIType.UniqueListeners,
      props.video.uniqueListeners,
      NumericalDataType.Units,
      props.video.uniqueListenersChange,
      calcPrevValue(props.video.uniqueListeners, props.video.uniqueListenersChange)
    )

  return (
    <tr class="hover:bg-gray-50">
      <td class="whitespace-nowrap border-r border-gray-200 px-3   py-3.5 text-center text-sm text-gray-700">
        {props.rowNumber}
      </td>
      <td>
        <div class="flex items-center gap-3">
          <Show when={props.video.imageUrl && props.video.imageUrl !== ''} fallback={<Video size={5} />}>
            <img
              src={props.video.imageUrl!}
              alt={props.video.name}
              class="h-5 w-5 flex-shrink-0 rounded object-cover"
            />
          </Show>
          <span class="text-sm font-medium text-gray-900">{props.video.name}</span>
        </div>
      </td>
      <td class="w-[188px]">
        <ValueProgressCell kpi={timesPlayedKPI()} />
      </td>
      <td class="w-[188px]">
        <ValueProgressCell kpi={uniqueListenersKPI()} />
      </td>
    </tr>
  )
}

export default VideosTableRow
